import InfoIcon from "@assets/icons/new/info-circle-fill-yellow.svg?react";
import { Alert, AlertProps } from "@mui/material";
import { neutral, yellow } from "@flat-ui";

/**
 * Renders a FARO alert.
 *
 * TODO: If a severity other than warning is used, the styling needs to be updated.
 */
export function FaroAlert(
  props: React.PropsWithChildren<AlertProps>
): JSX.Element {
  return (
    <Alert
      {...props}
      icon={props.severity === "warning" ? <InfoIcon /> : undefined}
      sx={{
        ...props.sx,
        fontSize: "14px",
        color: neutral[1000],
        backgroundColor: props.severity === "warning" ? yellow[50] : undefined,
      }}
    >
      {props.children}
    </Alert>
  );
}
